import { render, staticRenderFns } from "./deleteDialog.vue?vue&type=template&id=0e4a1d54&"
import script from "./deleteDialog.vue?vue&type=script&lang=ts&"
export * from "./deleteDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports